import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let CardComp;

class Card extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: CardComp };
      }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(
            import(/* webpackChunkName: "components/javascript/zcat-components/card-comp" */
            "../../../components/javascript/zcat-components/card-comp").then(function(res) {
                CardComp = res.CardComp;
            })
        );

        
;
    }
}

export {Card};

